import { Campaign } from '@central-products/welcome-messages-ui';
import { AdobePayloadData, CampaignMatcher, Maybe } from '~/typings';
import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';

export async function getCampaignFromActionContext({
  assetUrl,
  campaignName,
}: AdobePayloadData): Promise<Maybe<Campaign>> {
  const campaigns: Campaign[] = await fetchCampaigns(assetUrl);
  const campaignFilterMatcher = getCampaignFilterMatcher(campaignName);
  const campaign = campaigns.filter(campaignFilterMatcher).sort(lastUpdatedCampaign)[0];
  return campaign || undefined;
}

export function shouldReactOnAction(actionId: string) {
  return actionId === ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_OPEN;
}

async function fetchCampaigns(url: string): Promise<Campaign[]> {
  const response = await fetch(url).then((resp) => resp.json());
  return response.welcomeMessages;
}

function getCampaignFilterMatcher(campaignName: string): CampaignMatcher {
  return ({ campaign }: Partial<Campaign>) => campaign === campaignName;
}

function lastUpdatedCampaign(a: Campaign, b: Campaign) {
  return new Date(a.version) > new Date(b.version) ? -1 : 1;
}
